import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import moviesReducer from "./movieSlice";
import gptReducer from "./gptSlice";
import appConfigReducer from "./appConfigSlice";

const store = configureStore({
	reducer: {
		user: userReducer,
		movies:moviesReducer,
		gpt:gptReducer,
		appConfig:appConfigReducer
	},
});

export default store;